import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Questionary } from "../../../models/Questionary";
import { QuestionaryType } from "../../../models/QuestionaryType";
import QuestionaryTypeService from "../../../services/questionaryType.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faSave } from "@fortawesome/free-solid-svg-icons";

type Props = {
  onHide: () => void;
  onSave: (newQuestionary: Questionary) => void;
  userId: number;
  show: boolean;
};

export const ModalNewQuestionary = (props: Props) => {
  const [validated, setValidated] = useState(false);
  const [questionaryTypes, setQuestionaryTypes] = useState<QuestionaryType[]>(
    []
  );
  const [questionary, setQuestionary] = useState<Questionary>({
    name: "",
    isCompleted: false,
    questionaryTypeId: -1,
    email: "",
  });

  function handleQuestionaryTypeChange(e: any) {
    setQuestionary({
      ...questionary,
      questionaryTypeId: e.target.value,
    });
  }

  function handlenameChange(e: any) {
    setQuestionary({
      ...questionary,
      name: e.target.value,
    });
  }

  function handleEmailChange(e: any) {
    setQuestionary({
      ...questionary,
      email: e.target.value,
    });
  }

  const handleOnSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    questionary.userId = props.userId;
    props.onSave(questionary);
    setValidated(true);
  };

  useEffect(() => {
    async function loadData() {
      let questionaryTypesData =
        await QuestionaryTypeService.getQuestionaryTypes();
      setQuestionaryTypes(questionaryTypesData.filter((qt) => !qt.isArchived));
    }

    loadData();
  }, []);

  return (
    <Form validated={validated} noValidate>
      <Modal
        show={props.show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Nuevo cuestionario
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                onChange={handlenameChange}
                required={true}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                onChange={handleEmailChange}
                required={true}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label>Tipo de cuestionario</Form.Label>
              <Form.Select
                aria-label="Default select example"
                onChange={handleQuestionaryTypeChange}
                required={true}
              >
                <option>Seleccionar tipo de Cuestionario</option>
                {questionaryTypes
                  .filter((x) => x.isActive === true)
                  .map((f) => (
                    <option value={f.id}>{f.name}</option>
                  ))}
              </Form.Select>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide} variant="secondary">
            <FontAwesomeIcon icon={faBan} style={{ paddingRight: "3px" }} />
            <span className="ms-2">Cancelar</span>
          </Button>
          <Button type="submit" variant="primary" onClick={handleOnSubmit}>
            <FontAwesomeIcon
              icon={faSave}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Guardar</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </Form>
  );
};
